module.exports = __webpack_public_path__ + "img/h2.c777f7bd.jpg";